import React, { useRef } from "react";

import useContainerHeight from "../../../../common/useContainerHeight";
import { getTranslation } from "../../../../helpers/getLanguage";
import CustomScrollbar from "../../../common/CustomScrollbar";
import RowIdea from "./RowIdea";

const RowsIdeas = ({ rows, ideasPicked, handlePickedIdea }) => {
  const tableRef = useRef(null);
  const [containerHeight] = useContainerHeight(tableRef, 20);

  const reportsTableStyle = {};
  containerHeight && (reportsTableStyle.height = containerHeight);

  return (
    <div className="ideas-container" ref={tableRef} style={reportsTableStyle}>
      {rows?.length > 0 ? (
        <CustomScrollbar right={-15} dependencies={[rows]}>
          {rows.map((row) => (
            <RowIdea row={row} ideasPicked={ideasPicked} handlePickedIdea={handlePickedIdea} />
          ))}
        </CustomScrollbar>
      ) : (
        <div className="flex-column report-placeholder">
          <span>{getTranslation("NO_IDEAS_IN_TRASH")}</span>
          <span>{getTranslation("NO_TRASH_MESSAGE")}</span>
        </div>
      )}
    </div>
  );
};

export default RowsIdeas;
